export const APP_FOOTER = "AppFooter";
export const APP_STORE_BADGE = "AppStoreBadge";
export const PLAY_STORE_BADGE = "PlayStoreBadge";
export const APP_STORE_QUESTION = "AppStoreQuestion";
export const APP_STORE_BLURB = "AppStoreBlurb";
export const APP_STORE_INSTRUCTIONS = "AppStoreInstructions";
